import { render, staticRenderFns } from "./TurnListFilter.vue?vue&type=template&id=161daf53&scoped=true&"
import script from "./TurnListFilter.vue?vue&type=script&lang=js&"
export * from "./TurnListFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161daf53",
  null
  
)

export default component.exports